@if(enabled) {
  <div class="maintenance" id="maintenance">
    @switch (type) {
      @case (types.NO_INSTANCE) {
        <div class="no-instance">
          <img alt="Penceo" class="logo" src="assets/images/logo.png">
          <h1>Sorry, this instance does not exist.</h1>
        </div>
      }
      @case (types.SOFT_MAINTENANCE) {
        @if (softMaintenancePage) {
          <section class="maintenance__page" id="basic-page">
            <app-page [page]="softMaintenancePage"></app-page>
          </section>
        } @else {
          <ng-container *ngTemplateOutlet="basicMaintenanceTmp"></ng-container>
        }
      }
      @default {
        <ng-container *ngTemplateOutlet="basicMaintenanceTmp"></ng-container>
      }
    }

    <span class="version">
      Version: {{ version }}
    </span>  
  </div>
}

<ng-template #basicMaintenanceTmp>
  <div class="basic">
    <ng-lottie [options]="lottieOptions"></ng-lottie>
    <div class="wrapper">
      <h1>
        We are just publishing changes,<br>
        that will make <strong>easier</strong> for you to use<br>
        the platform.
      </h1>
      <h2>We will automatically redirect you when the system is back up</h2>
    </div>
 
    <div class="maintenance__status">
      @if (secondsTilNextRequest) {
        Site is still in maintenance mode. Next retry in: {{secondsTilNextRequest}} sec
      } @else {
        <span class="d-flex align-items-center maintenance__status-loading">
          Checking maintenance mode status
          <mat-spinner class="ml-2" [diameter]="16" color="primary"></mat-spinner>
        </span>
      }
    </div>  
  </div>
</ng-template>
